import { render, staticRenderFns } from "./PeopleOutlined.vue?vue&type=template&id=99116c02&"
import script from "./PeopleOutlined.vue?vue&type=script&lang=js&"
export * from "./PeopleOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports